export default __webpack_public_path__ + "static/media/pin.682bb957.svg";